import "./index.scss";

import { Box } from "@mui/material";
import CapsuleText from "components/CapsuleText";
import LabelWithValue from "components/LabelWithValue";
import TitleWithOptions from "components/TitleWithOptions";
import { WorkoutPlan } from "models/workoutplan";

const PrimaryDetailsSection = (props: { workoutPlan: WorkoutPlan; goalOptions: any[] }) => {
  const { workoutPlan, goalOptions } = props;
  return (
    <section className="primary-details-section">
      <TitleWithOptions title="Primary Details" />
      <Box sx={{ whiteSpace: "nowrap" }} width="fit-content" mt={1}>
        <LabelWithValue label="Workout Plan Name" value={workoutPlan?.workout_plan_name} />
      </Box>

      <Box display="flex" className="workout-plan-goal-container">
        <Box className="inner-container">
          <p className="section-title">Goals</p>
          {workoutPlan?.goals?.map((m, goalIndex) => {
            const entry = goalOptions.find((f) => f.value === m);
            if (!entry) return null;
            return <CapsuleText key={`goal${goalIndex}`} text={entry.label} />;
          })}
          {workoutPlan?.additional_goals?.length > 0 && (
            <>
              <p className="section-title second-title">Additional Goals</p>
              {workoutPlan?.additional_goals?.map((m, additionalGoalIndex) => {
                return <CapsuleText key={`goal${additionalGoalIndex}`} text={m} />;
              })}
            </>
          )}
        </Box>

        <Box className="inner-container">
          <p className="section-title">Included Programs</p>
          <Box display="flex" gap={1}>
            {workoutPlan?.isFlexibilityProgramIncluded && (
              <Box className="program-card">
                <img
                  alt="Flexibility"
                  src={require("assets/images/ui/flexibility.png")}
                  height="58px"
                />
                <p>Flexibility</p>
              </Box>
            )}

            {workoutPlan?.isCardioProgramIncluded && (
              <Box className="program-card">
                <img
                  alt="Flexibility"
                  src={require("assets/images/ui/cardiovascular.png")}
                  height="58px"
                />
                <p>Cardiovascular</p>
              </Box>
            )}

            {workoutPlan?.isStrengthProgramIncluded && (
              <Box className="program-card">
                <img
                  alt="Flexibility"
                  src={require("assets/images/ui/strength.png")}
                  height="58px"
                />
                <p>Strength</p>
              </Box>
            )}
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" flex={1} gap={1}>
          <Box className="inner-container">
            <p className="section-title">Instructor Notes</p>
            <CapsuleText
              text={workoutPlan?.instructor_notes || `N/A`}
              className="primary-details-container__note-text"
            />
          </Box>
          <Box className="inner-container">
            <p className="section-title">Warm Up Notes</p>
            <CapsuleText
              text={workoutPlan?.warm_up_notes || `N/A`}
              className="primary-details-container__note-text"
            />
          </Box>
        </Box>
      </Box>
    </section>
  );
};

export default PrimaryDetailsSection;
